import { getComponentsArrayBySelector } from '../utils/dom'

const PAGE_CONFIG = { DP_HOME_PAGE: 'stock-photos-graphics-home-page' }

const REQUEST_URL = '/profile/getCurrentDPSubscription?assetType=image'


document.addEventListener(
  'DOMContentLoaded',
  () => {
    const jsFormElement = window.document.querySelector('.js-newForm')

    if (jsFormElement) {
      const runSearchLib = () => {
        const url = new URL(window.location)
        const urlSearchParams = url.searchParams

        url.pathname = '/search'

        // musicType value for audio search
        const libraryEl = window.document.querySelector('input[name=library]')
        const sortByEl = window.document.querySelector('input[name=sortBy]')
        const excludeEl = window.document.querySelector('input[name=exclude]')
        const productTypeEl = window.document.querySelector('input[name=productType]')
        const assetType = window.document.querySelector('input[name=assetType]')
        const musicType = window.document.querySelector('input[name=musicType]')

        const urlParams = {
          library: (libraryEl && libraryEl.value) || null,
          sortBy: (sortByEl && sortByEl.value) || null,
          exclude: (excludeEl && excludeEl.value) || null,
          productType: (productTypeEl && productTypeEl.value) || null,
          assetType: (assetType && assetType.value) || null,
          musicType: (musicType && musicType.value) || null,
          // TODO: need to refactor multiple search inputs
          query: Array.from(window.document.querySelectorAll('input[name=query]')).map((el) => el.value).join(' ') || null,
        }

        Object.entries(urlParams)
          .filter(([_, value]) => Boolean(value))
          .forEach(([key, value]) => {
            urlSearchParams.set(key, value)
          })

        location.href = url.toString()
      }

      jsFormElement.onsubmit = (e) => {
        e.preventDefault()
        runSearchLib()
      }
    }

    const isDpHomePage = window.location.pathname.startsWith(`/${PAGE_CONFIG.DP_HOME_PAGE}`)
    const spiral = window.spiral

    if (isDpHomePage && spiral) {
      spiral.ajax({
        url: REQUEST_URL,
        method: 'GET',
        processAnswer ({
          response: {
            status,
            premiumDownloadsLeft,
            premiumDownloads,
            monthMark,
            planDuration,
            isUnlimited,
          },
          isSuccess,
        }) {
          const getDpComponents = (dataDpValue) => getComponentsArrayBySelector(`[data-dp='${dataDpValue}']`)

          const updateElementData = (dataDpValue, value) =>
            getDpComponents(dataDpValue).forEach((component) => {
              component.style.textTransform = 'lowercase'
              component.innerText = String(value)
            })

          const updateElementDisplay = (dataDpValue, isVisible = true) =>
            getDpComponents(dataDpValue).forEach((component) => {
              component.style.display = isVisible ? 'block' : 'none'
            })

          if (isSuccess || status === 200) {
            if (isUnlimited) {
              updateElementDisplay('is-limited', false)
            } else {
              updateElementData('premium-downloads', premiumDownloads)
              updateElementData('plan-duration', planDuration)

              updateElementData('premium-downloads-left', premiumDownloadsLeft)
              updateElementData('month-mark', monthMark)
            }
          } else {
            updateElementDisplay('is-limited', false)
            updateElementDisplay('no-subscription')
          }
        },
      })
    }
  },
)
